import type { FaireProductEntity } from "../../entity_types/product";

export const p_nj6wjp89dr: FaireProductEntity = {
  token: "p_nj6wjp89dr",
  type: "product",
  name: "Kelp Forest Shampoo 1/2 Gallon Refill",
  brandToken: "b_abkrtd2v7r",
  brandName: "Bathing Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/fab1038c874d8b2fe3ec2e3805950dae0f0d1c97ea9957bd4f310e49cc90adda.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/748251de3a8856f90a8c847e1736a3c4b43650e58d626632591d0505757bd79c.png",
    "https://cdn.faire.com/fastly/62ef622cb43d206dbdd2da5bc5de53f390339f57a89380096e5ad9649d60b384.png",
  ],
  priceDollars: 80,
  description:
    "\nLather up healthy, shiny, strong hair with this gentle shampoo made from biodegradable, cutting-edge plant-based chemistry and extracts of Sea Kelp, Amaranth, and more. Salon grade results with no compromises on personal or planetary safety.\n\nOur new scent Break Water smells like diving into 55º Pacific Waters, coastal scrub, and crisp ocean air.\n\nUnit Price: $80\nUnit Size: 64 fl oz (1.89L)\nMSRP: $160\nCase Size: 1 Unit\nUPC: Yes\n",
  tags: [],
  msrpDollars: 160,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:29.654Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
